import { useState, useMemo } from 'react';
import type { Job } from '../data/jobs';

export const useJobSearch = (jobs: Job[]) => {
  const [searchTerm, setSearchTerm] = useState('');

  const searchedJobs = useMemo(() => {
    if (!searchTerm.trim()) {
      return jobs;
    }

    const lowerSearchTerm = searchTerm.toLowerCase();
    return jobs.filter(job => 
      job.title.toLowerCase().includes(lowerSearchTerm) ||
      job.description.toLowerCase().includes(lowerSearchTerm) ||
      job.category.toLowerCase().includes(lowerSearchTerm) ||
      job.employmentType.toLowerCase().includes(lowerSearchTerm)
    );
  }, [jobs, searchTerm]);

  return {
    searchTerm,
    setSearchTerm,
    searchedJobs
  };
}; 